const CONSTANTS = {
    awsInputs: {
        region: 'us-east-1',
        roles: {
            contracts: 'nasco-evolve-contracts-role',
            contractSchemas: 'nasco-evolve-contractSchemas-role',
            approvals: 'nasco-evolve-approvals-role',
            users: 'nasco-evolve-users-role',
            userRoles: 'nasco-evolve-userRoles-role',
            authentication: 'nasco-evolve-authentication-role',
            reports: 'nasco-evolve-reports-role',
            media: 'nasco-evolve-media-role',
            fileStorage: 'nasco-evolve-fileStorage-role',
            workflows: 'nasco-evolve-workflows-role',
            systemConfig: 'nasco-evolve-systemConfig-role',
            tooltips: 'nasco-evolve-tooltips-role',
            redshiftAnalytics: 'nasco-evolve-redshiftAnalytics-role',
            settlements: 'nasco-evolve-settlements-role',
            flows: 'nasco-evolve-flows-role',
            flowExecution: 'nasco-evolve-flowExecution-role',
            contractIngestionStateMachine: 'nasco-evolve-contractIngestion-state-machine-role',
            contractIngestionStateMachineLambda: 'nasco-evolve-contractIngestion-state-machine-lambda-role',
            contractIngestionLambda: 'nasco-evolve-contractIngestion-lambda-role',
            nexus: 'nasco-evolve-nexus-role',
            playground: 'nasco-evolve-playground-role',
            exportDynamo: 'nasco-evolve-export-dynamo-role',
            default: 'nasco-evolve-default-role',
            s3Backup: 'nasco-nexus-s3-backup-role',
            dynamoBackup: 'nasco-nexus-dynamo-backup-role',
            redshiftBackup: 'nasco-nexus-redshift-backup-role',
            migration: 'nasco-evolve-migration-role'
        },
        os: {
            apiGatewayName: 'evolve-os-api-gateway',
            osCloudFrontDomainName: 'evolve-analytics',
            apiGatewayStageName: 'stage',
            frontEndBucketName: 'evolve-os-frontend'
        },
        settlement: {
            apiGatewayName: 'evolve-settlement-api-gateway',
            apiGatewayStageName: 'stage'
        },
        nexusPublicApi: {
            apiGatewayName: 'evolve-nexus-public-api-gateway',
            apiGatewayStageName: 'stage'
        },
        nexus: {
            redshiftWorkgroup: 'evolve-nexus-redshift-workgroup',
            redshiftDbName: 'evolve-nexus-redshift-db',
            apiGatewayName: 'evolve-nexus-api-gateway',
            redshiftRoleName: 'nasco-evolve-redshift-role-nexus',
            redshiftRoleBackupName: 'nasco-evolve-redshift-backup-role-nexus',
            apiGatewayStageName: 'stage',
            transactionDyanamoSufix: 'evolveNexus',
            frontEndBucketName: 'evolve-nexus-frontend'
        },
        contractIngestion: {
            apiGatewayName: 'evolve-contract-ingestion-api-gateway',
            apiGatewayStageName: 'stage'
        },
        dynamoTableName: {
            users: 'evolveUsers',
            workflows: 'evolveWorkflows',
            contracts: 'evolveContracts',
            flows: 'evolveFlows',
            systemConfigsCollection: 'evolveSystemConfigsCollection',
            flowExecutionEnvironments: 'evolveFlowExecutionEnvironments',
            flowExecutionEnvironmentMemories: 'evolveFlowExecutionEnvironmentMemories',
            settlements: 'evolveSettlements',
            adisSourceFiles: 'evolveADISSourceFiles',
            nexusChangelogs: 'evolveNexusChangelogs',
            userRoles: 'evolveUserRoles',
            tooltips: 'evolveTooltips',
            contractSchema: 'evolveContractSchema',
            report: 'evolveReports',
            queryLibrary: 'evolveQueryLibraryNexus',
            queryStats: 'evolveQueryStats',
            compiledReports: 'evolveCompiledReports',
            media: 'evolveMedia',
            approvals: 'evolveApprovals',
            roleMapping: 'evolveRoleMapping',
            settlementResults: 'evolveSettlementResults'
        },
        bucketSuffixName: {
            temporary: 'evolve-temporary',
            contractUploads: 'evolve-contract-uploads',
            memories: 'evolve-memories',
            synthData: 'evolve-synth-data',
            dynamo: 'evolve-dynamo',
            settlementArtifacts: 'evolve-settlement-artifacts',
            flowArtifacts: 'evolve-flow-artifacts',
            nexusToProcess: 'evolve-nexus-to-process',
            nexusFailedProcessing: 'evolve-nexus-failed-processing',
            nexusProcessed: 'evolve-nexus-processed',
            reports: 'evolve-reports',
            media: 'evolve-media',
            quarantine: 'evolve-quarantine',
            exportDynamo: 'evolve-export-dynamo',
            migration: 'evolve-migration',
            dev: 'evolve-dev'
        },
        cognito: {
            m2mUserPoolClientName: 'evolve-m2m-vbc-client-user-pool',
            m2mUserPoolIdentifier: 'evolve-m2m-api',
            scopeName: 'm2m.read',
            userPoolClientName: 'evolve-vbc-client-user-pool',
            userPoolName: 'evolve-vbc-user-pool',
            cognitoDomain: 'vbc'
        },
        schemas: {
            evolve: 'evolve',
            ngp: 'ngp',
            configuration: 'cfg',
            reference: 'reference'
        }
    },
    frontend: {
        version: '1.0.4'
    }
} as const

export { CONSTANTS }
